import React, { useContext, useEffect, useState } from 'react';
import Chart from '@/pages/Admin/Chart';
import MetricsChart from './MetricsChart';
import QuestionTimeChart from './QuestionTimeChart';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Widget, WidgetHeader, WidgetTitle, WidgetBody, WidgetWrapper } from '@/components/custom/widget';

function MetricsGeneral({ userId, user }) {
  const { t } = useTranslation();
  const client = useClient();
  const [metricsData, setMetricsData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const { data } = await client.fetch(`users/${userId}/metrics/general`);
      setMetricsData(data);
      setIsLoading(false);
    } catch (e) {
      toast.error(t('toast.error'));
      console.error(e);
    }
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <WidgetWrapper variant="chart">
        <Widget>
          <WidgetHeader>
            <WidgetTitle>Versões de projetos enviadas</WidgetTitle>
          </WidgetHeader>
          <WidgetBody>
            {(metricsData?.submitedProjects || []).length > 0 && (
              <Chart
                name="Versões"
                color="#442B8C"
                chartData={metricsData.submitedProjects}
              />
            )}
            {(metricsData?.submitedProjects || []).length === 0 && (
              <EmptyState
                type="data"
                text="Nenhum dado de versões enviadas"
              />
            )}
          </WidgetBody>
        </Widget>

        <Widget>
          <WidgetHeader>
            <WidgetTitle>Questões respondidas</WidgetTitle>
          </WidgetHeader>
          <WidgetBody>
            {(metricsData?.questionsAnswered || []).length > 0 && (
              <Chart
                name="Questões"
                color="#32C9D3"
                chartData={metricsData.questionsAnswered}
              />
            )}
            {(metricsData?.questionsAnswered || []).length === 0 && (
              <EmptyState
                type="data"
                text="Nenhum dado de questões respondidas"
              />
            )}
          </WidgetBody>
        </Widget>

        <Widget>
          <WidgetHeader>
            <WidgetTitle>Materiais acessados</WidgetTitle>
          </WidgetHeader>
          <WidgetBody>
            {(metricsData?.contentAccess || []).length > 0 && (
              <Chart
                name="Materiais"
                color="#FDB462"
                chartData={metricsData.contentAccess}
              />
            )}
            {(metricsData?.contentAccess || []).length === 0 && (
              <EmptyState
                type="data"
                text="Nenhum dado de materiais acessados"
              />
            )}
          </WidgetBody>
        </Widget>
      </WidgetWrapper>

      <WidgetWrapper variant="chart">
        <Widget>
          <WidgetHeader>
            <WidgetTitle>Solução de tarefas</WidgetTitle>
          </WidgetHeader>
          <WidgetBody>
            {metricsData?.accomplishedSlots && <MetricsChart chartData={metricsData?.accomplishedSlots} />}
            {!metricsData?.accomplishedSlots && (
              <EmptyState
                type="data"
                text="Nenhuma métrica de solução de tarefas"
              />
            )}
          </WidgetBody>
        </Widget>

        <Widget>
          <WidgetHeader>
            <WidgetTitle>Tempo acumulado em questões</WidgetTitle>
          </WidgetHeader>
          <WidgetBody>
            <QuestionTimeChart chartData={metricsData?.accumulatedTimeQuestions} />
          </WidgetBody>
        </Widget>
      </WidgetWrapper>
    </>
  );
}

export default MetricsGeneral;
